export const products = [
  // ===== NINTENDO SWITCH PRODUCTS =====
  {
    id: 1,
    name: "Nintendo Joycon Pikachu",
    category: "joycon",
    price: "S$89.99",
    originalPrice: "S$119.99",
    image: "/images/shop-products/nintendo-joycon-pikachu/transparent-pikachu.jpg",
    description: "Official Nintendo Switch Joy-Con controllers with Pikachu design, perfect for Pokemon fans",
    specs: {
      "Compatibility": "Nintendo Switch",
      "Connectivity": "Bluetooth 5.0",
      "Battery Life": "20+ hours",
      "Motion Controls": "HD Rumble",
      "NFC": "Amiibo Support"
    },
    features: [
      "Pikachu Yellow Design",
      "HD Rumble Technology",
      "Motion Controls",
      "Amiibo NFC Support"
    ],
    inStock: true,
    rating: 4.8,
    reviews: 1247
  },
  {
    id: 2,
    name: "4-in-1 Nintendo Switch Charging Dock – Charge Joy-Con & Pro Controller Simultaneously",
    category: "nintendo-accessories",
    price: "S$15.90",
    originalPrice: "S$25.90",
    image: "/images/shop-products/4in1-nintendo-switch-charger/2188924075f8db26abdfac88cdef15ac.png",
    description: "Charge Joy-Con & Pro Controller simultaneously with this 4-in-1 charging dock",
    specs: {
      "Output": "5V/2.1A",
      "Charging Ports": "4 USB-C",
      "Compatibility": "Switch, Joy-Cons, Pro Controller",
      "Material": "Premium ABS",
      "Warranty": "1 Year"
    },
    features: [
      "4 Simultaneous Charging",
      "Fast Charging Technology",
      "LED Status Indicators",
      "Compact Design"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 890
  },
  {
    id: 3,
    name: "Switch 2 Mini Joy-Con Keyboard & Mouse Base – Portable Dual-Set Gaming Accessory",
    category: "nintendo-switch",
    price: "S$12.90",
    originalPrice: "S$19.90",
    image: "/images/shop-products/switch-mouse-base/switch-2-mouse-base.jpg",
    description: "Portable dual-set gaming accessory combining mini keyboard and mouse base for enhanced Switch 2 gaming experience",
    specs: {
      "Material": "ABS Plastic",
      "Size": "12.5 × 7.3 × 6.2 cm",
      "Thickness": "Standard Molded ABS (Durable)",
      "Cover": "Open Dock Design",
      "Weight": "105g",
      "Color": "Black / Orange-Blue",
      "Compatibility": "Nintendo Switch 2 Joy-Con Controllers",
      "Surface": "Smooth Injection Molded Finish"
    },
    features: [
      "Dual-Set Design",
      "Portable Gaming Accessory",
      "Mini Keyboard Integration",
      "Joy-Con Compatible",
      "Durable ABS Construction",
      "Smooth Finish"
    ],
    inStock: true,
    rating: 4.4,
    reviews: 634
  },
  {
    id: 4,
    name: "Switch 2 Wrist Strap – Motion Sensor Hand Band for Fitness Boxing & Just Dance",
    category: "nintendo-accessories",
    price: "S$8.90",
    originalPrice: "S$15.90",
    image: "/images/shop-products/switch-wrist-strip/switch-2-joycon-strap.jpg",
    description: "Motion sensor hand band designed for fitness boxing and Just Dance with enhanced grip and motion tracking",
    specs: {
      "Material": "TPE Rubber + Copper Core",
      "Size": "Adjustable",
      "Color Options": "Blue-Orange",
      "Pack": "1 Pair",
      "Weight": "~80g",
      "Compatibility": "Nintendo Switch 2 Controllers",
      "Grip Type": "Adjustable Strap",
      "Washable": "Yes",
      "Breathability": "Skin-friendly",
      "Durability": "High Strength",
      "Installation": "Easy Plug & Play",
      "Maintenance": "Wipe Clean",
      "Warranty": "–",
      "Certification": "–",
      "Storage": "Dry & Cool Place",
      "Care Instructions": "Hand Wash, Air Dry"
    },
    features: [
      "Motion Sensor Technology",
      "Fitness Boxing Compatible",
      "Just Dance Ready",
      "Adjustable Strap Design",
      "Skin-friendly Material",
      "Easy Installation"
    ],
    inStock: true,
    rating: 4.3,
    reviews: 423
  },
  {
    id: 5,
    name: "Nintendo Switch 2 Power Adapter – 60W GaN PD Charger for Dock & Console",
    category: "nintendo-accessories",
    price: "S$39.99",
    originalPrice: "S$49.99",
    image: "/images/shop-products/switch-ac-adapter/switch 2 ac adapter.jpg",
    description: "Official Nintendo Switch AC adapter for fast charging",
    specs: {
      "Input": "100–220V AC",
      "Output": "DC 15V / 2.6A (approx.)",
      "Cable Length": "~1.5m",
      "Compatibility": "Nintendo Switch 2"
    },
    features: [
      "Official Nintendo Product",
      "Fast Charging",
      "Safety Protection",
      "Compact Design"
    ],
    inStock: true,
    rating: 4.7,
    reviews: 567
  },
  {
    id: 6,
    name: "Nintendo Switch 2 Controller Charger – 4-in-1 Dock for Joy-Con & Pro Pad",
    category: "nintendo-accessories",
    price: "S$19.90",
    originalPrice: "S$29.90",
    image: "/images/shop-products/switch-charger-dock/switch 2  4 in 1 controlller charger dock.jpg",
    description: "Dual charging dock for Switch and Joy-Cons with LED indicators",
    specs: {
      "Charging Ports": "2 (Switch + Joy-Cons)",
      "Output": "5V/2.1A",
      "LED Indicators": "Yes",
      "Material": "Premium ABS",
      "Weight": "200g"
    },
    features: [
      "Dual Charging",
      "LED Status Lights",
      "Stable Base",
      "Fast Charging"
    ],
    inStock: true,
    rating: 4.5,
    reviews: 345
  },
  {
    id: 7,
    name: "Switch Pro Controller",
    category: "nintendo-accessories",
    price: "S$27.90",
    originalPrice: "S$27.90",
    image: "/images/shop-products/switch-pro-controller/switch-wireless-gamepad.jpg",
    description: "Professional Switch controller with ergonomic design and long battery life",
    specs: {
      "Battery": "Built-in rechargeable lithium battery",
      "Connectivity": "Wireless Bluetooth + USB-C (charging/optional wired)",
      "Motion Controls": "Supported (6-axis gyroscope)",
      "NFC": "Not supported",
      "Weight": "330g",
      "Dimensions": "Approx. 15.5 x 10.5 x 6.5 cm",
      "Battery Life": "8–10 hours (depending on usage)"
    },
    features: [
      "Built-in Rechargeable Battery",
      "Wireless Bluetooth Connectivity",
      "6-Axis Gyroscope Motion Controls",
      "USB-C Charging Support",
      "Ergonomic Design"
    ],
    inStock: true,
    rating: 4.8,
    reviews: 789
  },
  {
    id: 8,
    name: "Switch Wireless Pro Controller – Clear Design with 6-Axis Gyro, Vibration & Customizable Buttons",
    category: "nintendo-accessories",
    price: "S$27.90",
    originalPrice: "S$27.90",
    image: "/images/shop-products/switch-pro-controller-deluxe/HONSON wireless gamepad.jpg",
    description: "Premium wireless controller with clear design, 6-axis gyro sensor, vibration feedback, and customizable buttons for ultimate gaming experience",
    specs: {
      "Battery": "Rechargeable Lithium Battery",
      "Connectivity": "Wireless Bluetooth / USB",
      "Motion Controls": "6-Axis Gyro Sensor",
      "Customizable": "Programmable Back Buttons & Macro Functions",
      "Weight": "270g",
      "Lighting": "7-Color LED Ambient Lights",
      "Compatibility": "Nintendo Switch / Switch Lite / PC / iOS / Android",
      "Dimensions": "150 × 105 × 62 mm"
    },
    features: [
      "6-Axis Gyro Sensor",
      "7-Color LED Ambient Lights",
      "Programmable Back Buttons",
      "Macro Functions",
      "Multi-Platform Compatibility",
      "Clear Design"
    ],
    inStock: true,
    rating: 4.9,
    reviews: 456
  },
  {
    id: 9,
    name: "Nintendo Switch 2 EVA Carrying Case – Handheld Storage Bag",
    category: "nintendo-accessories",
    price: "S$49.90",
    originalPrice: "S$59.90",
    image: "/images/shop-products/switch-portable-storage-bag/switch 2 All-In-One Carrying Case.jpg",
    description: "All-in-one carrying case for Switch 2 and accessories",
    specs: {
      "Material": "Waterproof Nylon",
      "Size": "30cm x 20cm x 8cm",
      "Pockets": "Multiple",
      "Waterproof": "Yes",
      "Weight": "400g"
    },
    features: [
      "Waterproof Protection",
      "Multiple Pockets",
      "Padded Interior",
      "Travel Friendly"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 234
  },
  {
    id: 10,
    name: "Nintendo Switch 2 Tempered Glass Screen Protector – HD, Matte & Anti-Blue Light Options",
    category: "nintendo-accessories",
    price: "S$8.90",
    originalPrice: "S$19.90",
    image: "/images/shop-products/switch-protect-screen/switch 2 protecter screen.jpg",
    description: "High-quality tempered glass screen protector for Switch 2 with anti-glare coating",
    specs: {
      "Material": "Tempered Glass",
      "Thickness": "0.3mm",
      "Anti-Glare": "Yes",
      "Pack": "2 Pieces",
      "Installation": "Easy",
      "Compatibility": "Switch 2",
      "Protection": "9H Hardness",
      "Clarity": "99.9% Transparency"
    },
    features: [
      "Tempered Glass",
      "Anti-Glare Coating",
      "Easy Installation",
      "2-Piece Pack",
      "9H Hardness",
      "99.9% Transparency",
      "Bubble-Free",
      "Crystal Clear"
    ],
    inStock: true,
    rating: 4.4,
    reviews: 567
  },

  // ===== GAMING ACCESSORIES =====
  {
    id: 11,
    name: "Wireless Keyboard",
    category: "keyboards",
    price: "S$20.90",
    originalPrice: "S$89.99",
    image: "/images/shop-products/wireless-keyboard/KEYBOARD ONLY.jpg",
    description: "3-Mode Wireless Bluetooth Keyboard and Mouse Set – Rechargeable, Compatible with 2.4G/BT 3.0/BT 5.0",
    specs: {
      "Connectivity": "2.4G + Bluetooth 3.0 + Bluetooth 5.0",
      "Charging": "USB-C Rechargeable",
      "Battery": "Long-lasting rechargeable",
      "Compatibility": "Multi-device support"
    },
    features: [
      "3-Mode Connectivity",
      "Rechargeable Battery",
      "Multi-Device Support",
      "Ergonomic Design"
    ],
    inStock: true,
    rating: 4.7,
    reviews: 892
  },
  {
    id: 14,
    name: "RGB Gaming Mouse Pad",
    category: "accessories",
    price: "S$9.90",
    originalPrice: "S$15.90",
    image: "/images/shop-products/rgb-gaming-mousepad/f59e02d9-c2e7-4117-a305-54251a6faeec.jpg",
    description: "Large RGB gaming mouse pad with customizable lighting effects",
    specs: {
      "Size": "350 x 250 / 800 x 300 (Thickness: 4mm)",
      "Material": "Cloth surface + Rubber base",
      "RGB Zones": "Multi-color RGB lighting effects",
      "Connectivity": "USB Hub powered",
      "Thickness": "4mm"
    },
    features: [
      "16 RGB Zones",
      "Large Gaming Surface",
      "Customizable Lighting",
      "Non-Slip Base"
    ],
    inStock: true,
    rating: 4.5,
    reviews: 456
  },
  {
    id: 15,
    name: "SUP Mini Retro Console – 400-in-1 Portable Handheld Game Player",
    category: "retro-gaming",
    price: "S$15.90",
    originalPrice: "S$25.90",
    image: "/images/shop-products/suip-400-gameboy/new-cover-3.jpeg",
    description: "Portable handheld game player with 400 built-in classic 8-bit games, featuring a 3.0-inch LCD display and rechargeable battery",
    specs: {
      "Screen": "3.0-inch LCD display",
      "Games": "400 built-in classic 8-bit games",
      "Battery": "1020mAh rechargeable lithium battery",
      "Storage": "128MB built-in",
      "Connectivity": "USB charging, AV output (wired for TV connection)",
      "Dimensions": "8 × 11.5 × 2.3 cm"
    },
    features: [
      "400 Classic 8-bit Games",
      "3.0-inch LCD Display",
      "Rechargeable Battery",
      "Portable Design",
      "TV Output Support",
      "USB Charging"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 789
  },
  {
    id: 16,
    name: "X7M Retro Handheld Game Console – SUP Style, 500 Classic Games, Big Screen, TV Output",
    category: "retro-gaming",
    price: "S$34.90",
    originalPrice: "S$49.90",
    image: "/images/shop-products/x7m-gameboy/cover.jpeg",
    description: "Classic retro handheld game console with 500 built-in FC games, 3.5-inch LCD display, and TV output for the ultimate nostalgic gaming experience",
    specs: {
      "Screen": "3.5-inch LCD Display",
      "Games": "500 Built-in Classic FC Games",
      "Battery": "Rechargeable 1020mAh Lithium Battery",
      "Storage": "128MB Internal Memory",
      "Connectivity": "USB / AV Output",
      "Dimensions": "17 × 8 × 2.3 cm (approx.)",
      "Weight": "0.43 kg",
      "Players": "Single & Double Player"
    },
    features: [
      "500 Classic FC Games",
      "3.5-inch LCD Display",
      "TV Output Support",
      "Dual Player Mode",
      "Rechargeable Battery",
      "Compact Design"
    ],
    inStock: true,
    rating: 4.7,
    reviews: 567
  },

  // ===== HOME DECOR & LIGHTING =====
  {
    id: 17,
    name: "Lava Lamp – EU Plug Retro Wax Light for Home & Holiday Decoration",
    category: "lava-lamp",
    price: "S$27.90",
    originalPrice: "S$39.90",
    image: "/images/shop-products/lava-lamp/Generated Image September 06, 2025 - 12_43AM.jpeg",
    description: "Classic lava lamp with mesmerizing liquid motion and ambient lighting",
    specs: {
      "Height": "Standard Size (Model LA-6122)",
      "Base": "Metal Base",
      "Bulb": "Incandescent/Standard Lava Lamp Bulb",
      "Colors": "Clear Red Wax, Clear Blue Wax, Clear Green Wax, Clear Orange Wax",
      "Material": "Metal + Glass",
      "Voltage": "220V (EU Plug)",
      "Style": "Modern Minimalist, Retro Motion Lamp",
      "Functions": "Night Light, Ambient Lighting"
    },
    features: [
      "Mesmerizing Motion",
      "Ambient Lighting",
      "Classic Design",
      "Energy Efficient"
    ],
    inStock: true,
    rating: 4.4,
    reviews: 345
  },
  {
    id: 18,
    name: "7-Color Flame Aromatherapy Diffuser – Realistic Flame Effect, Essential Oil Humidifier for Home & Office",
    category: "home-decor",
    price: "S$17.90",
    originalPrice: "S$25.90",
    image: "/images/shop-products/aromatherapy-diffuser/1.jpeg",
    description: "Ultrasonic diffuser with LED mood lighting and timer function",
    specs: {
      "Capacity": "300ml",
      "Runtime": "8-12 hours",
      "Timer": "1/3/6 hours",
      "Lighting": "7 Colors",
      "Noise": "<20dB"
    },
    features: [
      "Ultrasonic Technology",
      "7 Color LED",
      "Timer Function",
      "Quiet Operation"
    ],
    inStock: true,
    rating: 4.5,
    reviews: 234
  },
  {
    id: 19,
    name: "Hotel-Inspired Home Fragrance – Water-Soluble Aroma Oil, Smokeless (10ml)",
    category: "home-decor",
    price: "S$4.90",
    originalPrice: "S$6.90",
    image: "/images/shop-products/essential-oil-set/lemon.jpg",
    description: "Hotel-inspired water-soluble aroma oil for creating luxurious home fragrance without smoke or residue",
    specs: {
      "Volume": "10ml",
      "Type": "Water-Soluble",
      "Smoke": "Smokeless",
      "Purity": "100% Pure",
      "Packaging": "Glass Bottle"
    },
    features: [
      "Water-Soluble Formula",
      "Smokeless Operation",
      "Hotel-Quality Fragrance",
      "10ml Volume"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 456
  },
  {
    id: 21,
    name: "5050 RGB LED Strip Light Set – 5V USB Powered with 24-Key Remote & Bluetooth Control for TV Backlighting",
    category: "lighting",
    price: "S$39.99",
    originalPrice: "S$59.99",
    image: "/images/shop-products/led-light-500/led-light-500-1.jpeg",
    description: "Premium 5050 SMD LED strip lights with multiple dynamic modes, 24-key remote control, Bluetooth app control, and flexible 2m/5m/10m options for perfect home decoration",
    specs: {
      "LEDs": "12 LEDs/m (5050 SMD)",
      "Length": "2m / 5m / 10m",
      "Modes": "Multiple dynamic lighting modes (fade, jump, strobe, static, etc.)",
      "Control": "24-Key Remote / Bluetooth App / Bluetooth + Remote",
      "Power": "5V USB Powered",
    },
    features: [
      "5050 SMD LED Technology",
      "Multiple Dynamic Modes",
      "24-Key Remote + Bluetooth App",
      "Flexible 2m/5m/10m Options",
      "5V USB Powered"
    ],
    inStock: true,
    rating: 4.9,
    reviews: 687
  },
  {
    id: 22,
    name: "300 LED USB Curtain Lights – Decorative Glow for Home & Events",
    category: "lighting",
    price: "S$17.90",
    originalPrice: "S$29.99",
    image: "/images/shop-products/led-curtain-light/led-curtain-light-1.jpg",
    description: "Waterproof LED curtain lights for outdoor and indoor decoration with 300 LED lights and 8 different modes",
    specs: {
      "LEDs": "300",
      "Length": "3m x 3m",
      "Waterproof": "IP44",
      "Modes": "8 Different",
      "Power": "USB"
    },
    features: [
      "300 LED Lights",
      "Waterproof IP44",
      "8 Light Modes",
      "3m x 3m Size"
    ],
    inStock: true,
    rating: 4.9,
    reviews: 523
  },


  // ===== CABLES & CONNECTORS =====
  {
    id: 24,
    name: "HDMI Cable",
    category: "cables",
    price: "S$9.90",
    originalPrice: "S$9.90",
    image: "/images/shop-products/hdmi-cable/1.jpeg",
    description: "High-speed HDMI cable supporting 4K resolution and HDR",
    specs: {
      "Length": "2m",
      "Version": "HDMI 2.0",
      "Resolution": "4K@60Hz",
      "HDR": "Yes",
      "Material": "Gold Plated"
    },
    features: [
      "4K Resolution",
      "HDR Support",
      "Gold Plated",
      "2m Length"
    ],
    inStock: true,
    rating: 4.4,
    reviews: 789
  },

  // ===== NEW PRODUCTS =====
  {
    id: 25,
    name: "Karaoke Speaker and Mic",
    category: "audio",
    price: "S$89.99",
    originalPrice: "S$129.99",
    image: "/images/shop-products/karaoke-speaker-and-mic/1.jpg",
    description: "Portable karaoke system with dual wireless microphones and powerful speakers for ultimate party experience",
    specs: {
      "Power": "100W",
      "Battery": "5000mAh",
      "Connectivity": "Bluetooth 5.0 + AUX + USB",
      "Microphones": "Dual Wireless",
      "Range": "10m",
      "Lighting": "RGB Surround",
      "Charging": "USB-C",
      "Playback Time": "8-12 hours",
      "Weight": "2.5kg",
      "Dimensions": "30 x 20 x 15 cm"
    },
    features: [
      "Dual Wireless Microphones",
      "100W Powerful Sound",
      "RGB Surround Lighting",
      "Bluetooth 5.0",
      "Long Battery Life",
      "Portable Design"
    ],
    inStock: true,
    rating: 4.7,
    reviews: 234
  },
  {
    id: 26,
    name: "Quantum Wireless Gaming Mouse",
    category: "mice",
    price: "S$79.99",
    originalPrice: "S$119.99",
    image: "/images/products/placeholder.jpg",
    description: "High-precision wireless gaming mouse with quantum sensor technology, customizable RGB lighting, and ultra-low latency for competitive gaming",
    specs: {
      "Sensor": "Quantum 3399",
      "DPI": "Up to 20,000",
      "Polling Rate": "1000Hz",
      "Switches": "Omron 50M",
      "Battery": "70 hours",
      "Connectivity": "2.4GHz Wireless + Bluetooth",
      "Weight": "69g",
      "Dimensions": "12.5 x 6.5 x 4 cm",
      "RGB Zones": "3 zones"
    },
    features: [
      "Quantum Sensor Technology",
      "Ultra-low Latency",
      "70-hour Battery Life",
      "Customizable RGB",
      "Ergonomic Design",
      "Multi-device Support"
    ],
    inStock: true,
    rating: 4.8,
    reviews: 456
  },
  {
    id: 27,
    name: "Neon RGB Gaming Desk Mat",
    category: "accessories",
    price: "S$49.99",
    originalPrice: "S$69.99",
    image: "/images/products/placeholder.jpg",
    description: "Large RGB gaming desk mat with waterproof surface, anti-slip base, and customizable lighting effects for the ultimate gaming setup",
    specs: {
      "Size": "90 x 40 cm",
      "Thickness": "4mm",
      "Material": "Waterproof cloth + Rubber base",
      "RGB Zones": "12 zones",
      "Connectivity": "USB powered",
      "Waterproof": "IPX4",
      "Weight": "800g",
      "Compatibility": "All devices"
    },
    features: [
      "12 RGB Zones",
      "Waterproof Surface",
      "Anti-slip Base",
      "Large Gaming Area",
      "Customizable Lighting",
      "Easy to Clean"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 189
  }
];

// 分类数据
export const categories = [
  {
    id: "nintendo-switch",
    name: "Nintendo Switch",
    description: "Official Nintendo Switch accessories and controllers",
    image: "/images/products/placeholder.jpg",
    productCount: 10
  },
  {
    id: "keyboards",
    name: "Gaming Keyboards",
    description: "Professional mechanical keyboards for gaming",
    image: "/images/products/placeholder.jpg",
    productCount: 1
  },
  {
    id: "mice",
    name: "Gaming Mice",
    description: "High-precision gaming mice with advanced sensors",
    image: "/images/products/placeholder.jpg",
    productCount: 1
  },
  {
    id: "headsets",
    name: "Gaming Headsets",
    description: "Professional gaming headsets with immersive audio",
    image: "/images/products/placeholder.jpg",
    productCount: 0
  },
  {
    id: "accessories",
    name: "Gaming Accessories",
    description: "Essential gaming accessories and peripherals",
    image: "/images/products/placeholder.jpg",
    productCount: 2
  },
  {
    id: "retro-gaming",
    name: "Retro Gaming",
    description: "Classic handheld gaming devices and retro consoles",
    image: "/images/products/placeholder.jpg",
    productCount: 2
  },
  {
    id: "home-decor",
    name: "Home Decor",
    description: "Beautiful home decoration items and aromatherapy",
    image: "/images/products/placeholder.jpg",
    productCount: 3
  },
  {
    id: "lighting",
    name: "LED Lighting",
    description: "Creative LED lights and party lighting solutions",
    image: "/images/products/placeholder.jpg",
    productCount: 3
  },
  {
    id: "audio",
    name: "Audio Equipment",
    description: "Professional audio equipment and karaoke systems",
    image: "/images/products/placeholder.jpg",
    productCount: 1
  },
  {
    id: "cables",
    name: "Cables & Connectors",
    description: "High-quality cables and connection accessories",
    image: "/images/products/placeholder.jpg",
    productCount: 1
  }
];

// 精选产品
export const featuredProducts = [
  {
    id: 2,
    name: "4-in-1 Nintendo Switch Charging Dock – Charge Joy-Con & Pro Controller Simultaneously",
    category: "nintendo-accessories",
    price: "S$15.90",
    originalPrice: "S$25.90",
    image: "/images/shop-products/4in1-nintendo-switch-charger/2188924075f8db26abdfac88cdef15ac.png",
    description: "Charge Joy-Con & Pro Controller simultaneously with this 4-in-1 charging dock",
    inStock: true,
    rating: 4.6,
    reviews: 890
  },
  {
    id: 18,
    name: "7-Color Flame Aromatherapy Diffuser – Realistic Flame Effect, Essential Oil Humidifier for Home & Office",
    category: "home-decor",
    price: "S$17.90",
    originalPrice: "S$25.90",
    image: "/images/shop-products/aromatherapy-diffuser/1.jpeg",
    description: "Ultrasonic diffuser with LED mood lighting and timer function",
    inStock: true,
    rating: 4.5,
    reviews: 234
  },
  {
    id: 19,
    name: "Hotel-Inspired Home Fragrance – Water-Soluble Aroma Oil, Smokeless (10ml)",
    category: "home-decor",
    price: "S$4.90",
    originalPrice: "S$6.90",
    image: "/images/shop-products/essential-oil-set/lemon.jpg",
    description: "Hotel-inspired water-soluble aroma oil for creating luxurious home fragrance without smoke or residue",
    inStock: true,
    rating: 4.6,
    reviews: 456
  },
  {
    id: 24,
    name: "HDMI Cable",
    category: "cables",
    price: "S$9.90",
    originalPrice: "S$9.90",
    image: "/images/shop-products/hdmi-cable/1.jpeg",
    description: "High-speed HDMI cable supporting 4K resolution and HDR",
    inStock: true,
    rating: 4.4,
    reviews: 789
  }
];
